"use strict";
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialProgressStatus = void 0;
/** The progress status of a material for a user */
var MaterialProgressStatus;
(function (MaterialProgressStatus) {
    MaterialProgressStatus["COMPLETE"] = "complete";
    MaterialProgressStatus["INCOMPLETE"] = "incomplete";
})(MaterialProgressStatus = exports.MaterialProgressStatus || (exports.MaterialProgressStatus = {}));
